import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Shield, Eye, EyeOff, Loader2, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const [adminId, setAdminId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!adminId || !password) {
      toast.error('Preencha todos os campos');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${API}/super-admin/auth/login`, {
        admin_id: adminId,
        password
      });
      
      localStorage.setItem('halubri_super_admin_token', res.data.access_token);
      toast.success(`Bem-vindo, ${res.data.admin.name}!`);
      navigate('/super-admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenciais inválidas');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      {/* Back Link */}
      <div className="p-4">
        <Link to="/admin/login" className="text-zinc-400 hover:text-white flex items-center gap-2 text-sm">
          <ArrowLeft className="w-4 h-4" /> Voltar para Portal Funcionário
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto bg-sonangol-orange/20 rounded-2xl flex items-center justify-center mb-4">
              <Shield className="w-10 h-10 text-sonangol-orange" />
            </div>
            <h1 className="font-barlow text-3xl font-bold text-white">SUPER ADMIN</h1>
            <p className="text-zinc-400 mt-2">Acesso restrito · HáLubri Sonangol</p>
          </div>

          {/* Login Form */}
          <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-6">
            <form onSubmit={handleLogin} className="space-y-5">
              <div className="space-y-2">
                <Label className="text-zinc-400">ID de Administrador</Label>
                <Input
                  placeholder="ADMIN-SONANGOL-001"
                  value={adminId}
                  onChange={(e) => setAdminId(e.target.value)}
                  className="bg-zinc-800 border-zinc-700 h-12 text-white"
                  data-testid="super-admin-id-input"
                />
              </div>

              <div className="space-y-2">
                <Label className="text-zinc-400">Palavra-passe</Label>
                <div className="relative">
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="bg-zinc-800 border-zinc-700 h-12 pr-12 text-white"
                    data-testid="super-admin-password-input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-white"
                  >
                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>

              <Button
                type="submit"
                className="w-full h-12 bg-sonangol-orange hover:bg-orange-600 font-barlow font-bold uppercase tracking-wider"
                disabled={loading}
                data-testid="super-admin-login-btn"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin mr-2" />
                    A verificar...
                  </>
                ) : (
                  'Entrar'
                )}
              </Button>
            </form>
          </div>

          {/* Security Notice */}
          <div className="mt-6 p-4 bg-red-900/20 border border-red-700/50 rounded-lg">
            <p className="text-red-400 text-sm text-center">
              <Shield className="w-4 h-4 inline-block mr-1" />
              Este portal é de acesso restrito. Todas as acções são registadas.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
